import { useEffect, useRef, useState } from 'react';

const useUserMenu = () => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const avatarRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const close = () => {
    setShowUserMenu(false);
  };

  const toggle = () => {
    setShowUserMenu(prevShow => !prevShow);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        avatarRef.current?.contains(event.target as Node) ||
        menuRef.current?.contains(event.target as Node)
      )
        return;

      close();
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [avatarRef, menuRef]);

  return {
    showUserMenu,
    close,
    toggle,
    avatarRef,
    menuRef,
  };
};

export { useUserMenu };
